import axios from 'axios';

const TOKEN_KEY = 'freejini_token';
const USER_KEY = 'freejini_user';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUser = () => JSON.parse(localStorage.getItem(USER_KEY) || 'null');
export const isLoggedIn = () => !!getToken();

export const saveAuth = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

const api = axios.create({ baseURL: '/api', timeout: 15000 });

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const loginRequest = (email, password) =>
  api.post('/auth/login', { email, password }).then(r => r.data);

export const registerRequest = (email, name, password) =>
  api.post('/auth/register', { email, name, password }).then(r => r.data);

export const updateProfileRequest = (name, email) =>
  api.put('/auth/profile', { name, email }, authHeaders()).then(r => r.data);

export const updatePasswordRequest = (currentPassword, newPassword) =>
  api.put('/auth/password', { currentPassword, newPassword }, authHeaders()).then(r => r.data);
